var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVendorships(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#112d55",
    d: "M7 2a2 2 0 0 0-1.93 1.474l-3 11A2 2 0 0 0 2 15a8.977 8.977 0 0 0 3 6.708V52c0 5.523 4.477 10 10 10h17a2 2 0 1 0 0-4H15a6 6 0 0 1-6-6V23.777A9.033 9.033 0 0 0 11 24a8.983 8.983 0 0 0 7-3.343C19.65 22.697 22.173 24 25 24s5.35-1.304 7-3.343C33.65 22.697 36.173 24 39 24s5.35-1.304 7-3.343A8.983 8.983 0 0 0 53 24c.687 0 1.357-.077 2-.223V33.5a2 2 0 1 0 4 0V21.708A8.978 8.978 0 0 0 62 15c0-.178-.024-.355-.07-.526l-3-11A2 2 0 0 0 57 2zm18 18a5 5 0 0 1-5-5 2 2 0 1 0-4 0 5 5 0 0 1-9.994.246L8.528 6h46.944l2.522 9.246A5 5 0 0 1 48 15a2 2 0 1 0-4 0 5 5 0 0 1-10 0 2 2 0 1 0-4 0 5 5 0 0 1-5 5z",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e9941",
    d: "M57 43a7.971 7.971 0 0 1-2.106 5.41A13 13 0 0 1 62 60a2 2 0 1 1-4 0 9 9 0 1 0-18 0 2 2 0 1 1-4 0 13 13 0 0 1 7.106-11.59A8 8 0 1 1 57 43zm-12 0a4 4 0 1 1 8 0 4 4 0 0 1-8 0z",
    opacity: 1,
    "data-original": "#fa1228",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorships);
export default __webpack_public_path__ + "static/media/vendorships.e22f51c2f113ec852c08dbf78958eaeb.svg";
export { ForwardRef as ReactComponent };